var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-app", [
    _vm.loaded
      ? _c(
          "div",
          [
            _c("button", { staticClass: "btn", on: { click: _vm.test } }, [
              _vm._v(" TEST auth (click) ")
            ]),
            _c("BR"),
            _vm._v(" " + _vm._s(_vm.testMsg) + " "),
            _c("BR"),
            _c("h1", [_vm._v("Hello " + _vm._s(_vm.user.username))]),
            _c("h1", [_vm._v("Tenant " + _vm._s(_vm.user.attributes.tenant))]),
            _c("h1", [_vm._v("---")]),
            _c("h1", [_vm._v("Hello " + _vm._s(_vm.user))])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }